import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/packing/show_process/${organization_id}/fetch_harvest_process/${harvest_process_id}`
    );
  },
  fetchHarvestedBatch(organization_id, harvested_batch_id) {
    return RequesterV1.get(
      `organization/process/packing/show_harvested_batch/${organization_id}/fetch_harvested_batch/${harvested_batch_id}`
    );
  },
  fetchPackages(organization_id, harvested_batch_id) {
    return RequesterV1.get(
      `organization/process/packing/show_harvested_batch/${organization_id}/fetch_packages/${harvested_batch_id}`
    );
  }
};
